import { createContext, useContext } from 'react';
import type { useApiTriggeredBroadcasts } from '@/services/db/campaign/queries';
import type { useFilteredNewsletters } from '@/services/db/newsletter/queries';
import type { SavedBroadcastsSearches } from './use-broadcasts-list';

type BroadcastsListContextValue = {
  /** Each tab's search as the reader left it, for as long as the page stays open. */
  saved: SavedBroadcastsSearches;
  /**
   * The frame's reads of both tabs. A tab body renders its own from here rather than reading
   * again, so its rows, counts and error reporting are the frame's, not a second observer's.
   */
  newslettersQuery: ReturnType<typeof useFilteredNewsletters> | null;
  apiTriggeredQuery: ReturnType<typeof useApiTriggeredBroadcasts> | null;
};

export const BroadcastsListContext = createContext<BroadcastsListContextValue>({
  saved: {},
  newslettersQuery: null,
  apiTriggeredQuery: null,
});

/** The Broadcasts frame's state, for the routes rendered inside it. */
export function useBroadcastsListContext(): BroadcastsListContextValue {
  return useContext(BroadcastsListContext);
}
